module.exports = __webpack_public_path__ + "static/media/level_handle.ff6d6aa3.svg";